
  export default {
    props:['jobUrl', 'countryUrl', 'country']



  }
